import { render } from "./VtoFloatingBar.vue?vue&type=template&id=78d68bbc"
import script from "./VtoFloatingBar.vue?vue&type=script&lang=js"
export * from "./VtoFloatingBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__